import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import i18n from "@/core/plugins/i18n";
import "dayjs/locale/es";
import ElementPlus from "element-plus";
import ElementPlusEs from "element-plus/es/locale/lang/es";
import router from "./router";
import store from "./store";
// Yup locale
import { setLocale } from "yup";
import { es } from "yup-locales";
setLocale(es);

//imports for app initialization
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import ApiService from "@/core/services/ApiService";

import "@/core/plugins/prismjs";
import "bootstrap";

const app = createApp(App);

app.use(store);
app.use(router);

app.use(ElementPlus, {
  locale: ElementPlusEs,
});
ApiService.init(app);
ApiService.setupInterceptors(store);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
